import { Stack } from '@mui/material';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

import { ChipParameterDialog } from '../Range/Dialog';

/**
 * Normal-range chip in the drilldown banner.
 *
 * The unit toggle used to sit here too. It moved onto the chart/table card as
 * a {@link UnitPill}, next to the values it applies to.
 */
export default function UnitRange() {
  const isMobile = useIsMobile();

  return (
    <Stack
      direction="row"
      justifyContent={'space-between'}
      mt={1}
      mx={isMobile ? 2 : 0}
      mr={isMobile ? 0 : 2}
    >
      <ChipParameterDialog />
    </Stack>
  );
}
